<template>
  <div
    class="add-card-details"
    :class="{ px30: $store.state.loginActiveStep === 'addCard' }"
  >
    <h2
      class="page-title text-24 p-0 text-text text-left tracking-normal mb-5 text-secondary"
    >
      {{ $t("Add your card details") }}
    </h2>
    <div class="bg-white rounded-8 shadow-primary min-h-230 my-10 relative">
      <div
        class="w-108-p bg-white -ml-3.5 pt-5 pr-5 pl-8 pb-7 rounded-8 shadow-primary"
      >
        <img
          width="32px"
          height="21px"
          class="object-cover absolute right-6"
          :src="`${$getState('appUrl')}/img/pwa/signal.png`"
        />
        <img
          width="44px"
          height="44px"
          class="pt-3 object-cover"
          :src="`${$getState('appUrl')}/img/pwa/chip.png`"
        />
        <div class="mt-5">
          <span class="text-30 text-text">**** **** **** *****</span>
        </div>
        <div class="flex justify-between items-start">
          <span class="text-12 text-label"> {{ cardHolderName }} </span>
          <div class="mr-10">
            <span class="block text-12 text-label">Expires</span>
            <span>--/--</span>
          </div>
        </div>
      </div>
    </div>
    <div id="card-errors" role="alert"></div>
    <div
      class="card-form form-items p-0 credit-card"
      :class="{
        'form-enabled':
          cardValues.name &&
          cardComplete.cardNumber &&
          cardComplete.cardExpiry &&
          cardComplete.cardCvc
      }"
    >
      <form
        id="stripe-payment-form"
        :class="{ 'filter blur-sm': !isStripeForm }"
      >
        <div class="form-item-row">
          <div id="card-number" class="stripe-input-wrapper"></div>
        </div>
        <div class="form-item-row">
          <FormulateInput
            v-model="cardValues.name"
            type="text"
            name="name"
            :placeholder="$t('Card Holder Name')"
            validation="required"
          />
        </div>
        <div class="form-item-row">
          <div id="card-expiry" class="stripe-input-wrapper"></div>
        </div>
        <div class="form-item-row">
          <div id="card-cvc" class="stripe-input-wrapper"></div>
        </div>
        <div class="form-item-row">
          <FormulateInput
            v-model="cardValues.saveCard"
            type="checkbox"
            :label="$t('Save card for monthly roundups')"
          />
        </div>
        <div class="form-item-row">
          <FormulateInput type="submit" :label="$t('Save & Review')" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import McIcon from "../Icons/McIcon";
export default {
  name: "AddCard",
  props: {
    cardsCount: {
      type: Number,
      default: 0
    }
  },

  components: {
    McIcon
  },

  data: function() {
    return {
      cardValues: {
        name: "",
        saveCard: false,
        number: "**** **** **** ****",
        date: "--/--"
      },
      cardNumber: "",
      cardDate: "",
      currentSlide: 1,
      stripeObj: null,
      showSubscribeFields: true,
      formStyle: {
        base: {
          color: "#7c7d7e",
          fontWeight: 700,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#7c7d7e"
          }
        },
        invalid: {
          color: "#ff0000",
          iconColor: "#ff0000"
        }
      },
      cardCompleteNumber: false,
      cardCompleteCvc: false,
      cardCompleteExpiry: false,
      cardComplete: {
        cardCvc: false,
        cardExpiry: false,
        cardNumber: false
      },
      isStripeForm: false
    };
  },

  mounted() {
    this.stripeInit();
  },

  computed: {
    cardHolderName() {
      return this.cardValues.name || "Card Holder Name";
    }
  },

  methods: {
    // formHandler: function() {
    //     this.$emit("goNextCardProcess", "authorize");
    // },
    changeCardNumber: function() {
      const str = String(this.cardNumber);
      if (str.length <= 16)
        this.cardValues.number = str
          .replace(/\s/g, "")
          .replace(/(\d{4})/g, "$1 ")
          .trim();

      if (str.length > 16) {
        this.cardNumber = this.cardValues.number.replace(/\s/g, "");
      }
    },
    stripeInit: function() {
      if (window.Stripe === undefined) {
        let stripeScript = document.createElement("script");
        stripeScript.setAttribute("src", "https://js.stripe.com/v3/");
        document.head.appendChild(stripeScript);
        stripeScript.onload = () => {
          this.initStripeElements();
        };
      } else {
        this.initStripeElements();
      }
    },
    initStripeElements() {
      let app = this;

      if (!this.$getState("stripeKey")) {
        this.showSubscribeFields = false;
        return false;
      } else {
        this.showSubscribeFields = true;
      }

      this.stripeObj = Stripe(this.$getState("stripeKey"));
      let http = this.$http;

      let stripe = this.stripeObj;
      let elements = stripe.elements({ locale: app.$i18n.locale });

      const elementClasses = {
        focus: "focused",
        empty: "empty",
        invalid: "invalid"
      };

      const cardNumber = elements.create("cardNumber", {
        style: this.formStyle,
        classes: elementClasses,
        placeholder: app.$t("Card Number")
      });
      cardNumber.mount("#card-number");
      cardNumber.on("change", function(event) {
        displayError(event, "cardNumber");
      });

      const cardExpiry = elements.create("cardExpiry", {
        style: this.formStyle,
        classes: elementClasses,
        placeholder: app.$t("Expiration Date")
      });
      cardExpiry.mount("#card-expiry");
      cardExpiry.on("change", function(event) {
        displayError(event, "cardExpiry");
      });

      const cardCvc = elements.create("cardCvc", {
        style: this.formStyle,
        classes: elementClasses,
        placeholder: app.$t("Security Code (CCV)")
      });
      cardCvc.mount("#card-cvc");
      cardCvc.on("change", function(event) {
        displayError(event, "cardCvc");
      });

      let form = document.getElementById("stripe-payment-form");
      form.addEventListener("submit", function(event) {
        event.preventDefault();
        createPaymentMethod({ cardNumber });
      });
      app.isStripeForm = true;

      function displayError(event, type) {
        const typeObj = {};
        if (event.error) {
          typeObj[type] = false;
          app.cardComplete = { ...app.cardComplete, ...typeObj };
          app.$toastr.e(event.error.message);
        } else {
          displayError.textContent = "";
          typeObj[type] = true;
          app.cardComplete = { ...app.cardComplete, ...typeObj };
          console.log(app.cardValues, "cardValues");
        }
      }

      function createPaymentMethod({ cardNumber }) {
        stripe
          .createPaymentMethod({
            type: "card",
            card: cardNumber,
            billing_details: {
              name: app.cardValues.name
            }
          })
          .then(result => {
            if (result.error) {
              displayError(result.error);
            } else {
              createCustomer(result.paymentMethod.id);
            }
          });
      }

      function createCustomer(paymentMethodId) {
        const processType = app.$route.path === "/login" ? "signUp" : "";

        http
          .post("user/savecard", {
            payment_method_id: paymentMethodId,
            save_card: app.cardValues.saveCard,
            process_type: processType,
            save_card: app.cardsCount ? app.cardValues.saveCard : true
          })
          .then(data => {
            if (data && data.status !== undefined && data.status) {
              const user = data.data.user;
              app.$setState("userUpdate", user);
              if (user.pr_card && app.$route.path === "/login") {
                app.$emit("goNextCardProcess", "donation");
              }

              if (app.$route.path === "/settings") {
                app.$emit("actionWithCard", {
                  action: "update"
                });
              }
            }
          });
      }
    }
  }
};
</script>
